<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent width="500">
      <v-card class="py-6">
        <v-card-title>
          <v-row>
            <v-col cols="10">
              <div class="title">
                Regularly using Covesto? Keep your <br />
                streak and earn Coins!
              </div>
            </v-col>
            <v-col cols="1">
              <v-icon class="ml-8" @click="closeDialog"
                >mdi-close-circle</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="mt-6">
          <div class="d-flex">
            <div class="mr-2">
              <v-img class="img ml-3" :src="dotted_line"></v-img>
            </div>
            <div class="mr-3">
              <div class="mt-1 count">1:</div>
              <div class="mt-10 count">2:</div>
              <div class="mt-15 count">3:</div>
            </div>
            <div>
              <div>
                <div class="heading">Log in</div>
                <div class="sub-text">to Covesto every trading day.</div>
              </div>

              <div class="mt-7">
                <div class="heading">Earn Covesto Coins</div>
                <div class="sub-text">
                  by completing at least one task each day to maintain your
                  streak.
                </div>
              </div>

              <div class="mt-6">
                <div class="heading">Unlock Premium Services</div>
                <div class="sub-text">by using your Covesto coins</div>
              </div>
            </div>
          </div>
          <div class="mt-4">
            <v-img :src="streak_mobile"></v-img>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn class="text-none btn-text" block @click="routeToGamification"
            >Next</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  name: "thanksExpertDialog",
  data() {
    return {
      dotted_line: require("@/assets/images/trending/dotedLine.png"),
      streak_mobile: require("@/assets/images/trending/streakMobile.svg"),
    };
  },
  computed: {
    show() {
      return this.$store.state.gamification.streakModal.show;
    },
  },
  methods: {
    closeDialog() {
      this.$store.commit("gamification/TOGGLE_STREAK_MODAL", { show: false });
    },
    routeToGamification() {
      this.$router.push({ name: "Gamification" });
    },
  },
};
</script>
<style scoped>
.title {
  font-family: Avenir;
  font-size: 22px;
  font-weight: 600;
  line-height: 30.05px;
  color: #333333;
  margin-left: 20px;
}
.img {
  height: 200px;
  width: 4px;
}
.sub-text {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: grey;
}
.heading {
  font-family: Avenir;
  font-size: 18px;
  font-weight: 800;
  line-height: 24px;
  color: #333333;
}
.count {
  font-family: Avenir;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  color: #a48b00;
}
/* .btn-text{
    font-family: Avenir;
    font-size: 20px;
    font-weight: 600;
    line-height: 27.32px;
    color: #6A5A02;
    
  }*/

.btn-text {
  background-image: linear-gradient(
    to right,
    #d6c58d 0%,
    #ffe68e 51%,
    #dcc05c 100%
  );
}
.btn-text {
  text-align: center;
  transition: 0.5s;
  background-size: 200% auto;
  color: #6a5a02;
  box-shadow: 0 0 20px #eee;
  border-radius: 10px;
  display: block;
}

.btn-text:hover {
  background-position: right center; /* change the direction of the change here */
  color: #6a5a02;
  text-decoration: none;
}
@media only screen and (max-width: 600px) {
  .title {
    font-family: Avenir !important;
    font-size: 14px !important;
    font-weight: 600;
    line-height: 21.86px;
    color: #333333;
    margin-left: 10px;
  }
  .heading {
    font-family: Avenir;
    font-size: 16px;
    font-weight: 800;
    line-height: 20px;
    color: #333333;
  }
  .sub-text {
    font-family: Avenir;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    color: grey;
  }
  .count {
    font-family: Avenir;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color: #a48b00;
  }
}
</style>
